// @flow
import { connect } from "react-redux";

import { logout } from "../actions/SignOut";

import type { ReduxState, ThunkAction } from "../types";
import type { ComponentType } from "react";
import { getApplication } from "../_modularui";

type StateProps = {
  isAuthenticated: boolean,
};

type DispatchProps = {
  doLogout: () => ThunkAction<>,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  isAuthenticated: getApplication(state)?.isLoggedIn ?? false,
});

const mapDispatchToProps = { doLogout: logout };

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useLogout' instead
 */
export const connectSignOut: ComponentType<any> = connect<
  Props,
  {},
  StateProps,
  _,
  _,
  _,
>(mapStateToProps, mapDispatchToProps);
